export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";